import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { useReserve } from "@/components/boost/ReserveContext";

const FinalCTA = () => {
  const { open } = useReserve();
  return (
    <section className="relative section-pad overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(70% 60% at 50% 0%, rgba(16,185,129,0.12), transparent 60%), radial-gradient(50% 40% at 100% 100%, rgba(163,230,53,0.15), transparent 60%), linear-gradient(180deg, #ffffff, #f5f7fa)",
        }}
      />
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[36px] border border-white/70 glass-light shadow-premium overflow-hidden p-8 sm:p-14 text-center"
        >
          <div className="aurora opacity-50" aria-hidden />
          <div className="relative z-10">
            <div className="chip mx-auto"><span className="live-dot" /> Ready when you are</div>
            <h2
              className="mt-6 mx-auto font-display font-extrabold tracking-tight text-slate-900"
              style={{ fontSize: "clamp(2.25rem, 5vw, 4.25rem)", letterSpacing: "-0.03em" }}
            >
              Ready To Build Your <span className="gradient-text-emerald">First Online Business?</span>
            </h2>
            <p className="mt-4 max-w-xl mx-auto text-slate-600">
              Reserve your seat, join a serious community and start building — for just ₹399.
            </p>
            <button
              onClick={open}
              data-testid={HOME.finalCta}
              className="mt-8 btn-primary h-14 px-8 text-lg"
            >
              Reserve My Seat
              <ArrowUpRight className="w-5 h-5" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
